module.exports = __webpack_public_path__ + "static/media/S2N14-1.3ff54b3b.svg";